export const TOGGLE_EQUIPMENTFILTERS = '@@equipmentfilters/TOGGLE_EQUIPMENTFILTERS';

export const toggleEquipmentVariantSelector = visible => ({
  type: TOGGLE_EQUIPMENTFILTERS,
  visible
});
